<template>
    <div class="header">
        <div class="container container-menu">
            <nav class="navbar navbar-expand-lg navbar-light bg-light">
                <div class="btn-group menu d-none d-lg-flex">
                    <client-sites v-if="this.$route.path !== '/login' && this.$route.path !== '/logout' && loggedIn"></client-sites>
                    <br>
                    <slave-clients v-if="(userType == 'admin' && clientRole == 'master' || userType == 'superadmin') && this.$route.path !== '/login' && this.$route.path !== '/logout' && loggedIn"></slave-clients>
                </div>
                <div class="client-logo-sm d-lg-none">
                    <img v-if="clientLogo != null" :src="clientLogo" :alt="clientName + ' Logo'" class="client-logo-sm-img">
                </div>
                <a class="navbar-brand" href="#">
                    <img class="logo" src="/assets/img/png/logo.png" alt="temeter">
                </a>
            
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <img src="/assets/img/svg/burger.svg" alt="">
                </button>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav mr-auto">
                        <li class="nav-item">
                            <a class="nav-link" href="#">{{ clientName }}</a>
                        </li>
                        <li class="nav-item">
                            <router-link to="/logout" class="dropdown-item">Logout</router-link>
                        </li>
                        <div class="dropdown-divider"></div>
                        <template v-if="this.$route.path !== '/login' && this.$route.path !== '/logout' && loggedIn">
                            <li class="nav-item nav-sm">
                                <span class="nav-link text-left">Sito</span>
                            </li>
                            <li class="nav-item dropdown nav-sm">
                                <client-sites></client-sites>                            
                            </li>
                        </template>
                        <template v-if="(userType == 'admin' && clientRole == 'master' || userType == 'superadmin') && this.$route.path !== '/login' && this.$route.path !== '/logout' && loggedIn">
                            <li class="nav-item nav-sm">
                                <span class="nav-link text-left">Cliente</span>
                            </li>
                            <li class="nav-item dropdown nav-sm mb-3">
                                <slave-clients></slave-clients>
                            </li>
                        </template>
                    </ul>
                </div>

                <div class="user d-none d-lg-flex">
                    <template v-if="this.$route.path !== '/login' && this.$route.path !== '/logout' && loggedIn">
                        <div class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle username" href="#" role="button"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {{ clientName }}
                            </a>
                            <div class="dropdown-menu dropdown-menu-center" aria-labelledby="username">
                                <a class="dropdown-item" href="#">profilo</a>
                                <a class="dropdown-item" href="#">impostazioni</a>
                                <router-link to="/logout" class="dropdown-item">Logout</router-link>
                            </div>
                        </div>
                        <img v-if="clientLogo != null" :src="clientLogo" :alt="clientName + ' Logo'">
                        <!-- <a id="help" href="#">?</a> -->
                    </template>
                </div>
            </nav>
        </div>
    </div>
</template>

<script>
    import ClientSites from './header/ClientSites.vue'
    import SlaveClients from './header/SlaveClients.vue'
    import { mapGetters } from 'vuex'

    export default {
        components: {ClientSites, SlaveClients},
  
        computed: {
            ...mapGetters([
                'loggedIn',
                'clientName',
                'clientLogo',
                'userType',
                'clientRole'            
            ])
        }
    }
</script>

<style>
.client-logo-sm-img {
    width: 50px;
}
.nav-sm {
    padding: 0px 22px;
}
</style>